// removed by extract-text-webpack-plugin
module.exports = {"timesheetControl":"styles__timesheetControl___2DFjw","promptProjectText":"styles__promptProjectText___1KpnW","weekControl":"styles__weekControl___HDPUz","timesheetButton":"styles__timesheetButton___1JVcg","projectEmptyMode":"styles__projectEmptyMode___2OFwH","selectProjectButton":"styles__selectProjectButton___2wt1K","overtimePreviewButton":"styles__overtimePreviewButton___2cq0q","projButton":"styles__projButton___10A0E"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timesheet/control/styles.scss
// module id = 473
// module chunks = 0